// import { createTooltip } from '@/common/chart-options';
import dayjs from 'dayjs';


const $str = window.$str


// // 模拟数据（0~24时）
// for (let i = 0; i <= 24; i++) {
//   hours.push(`${i}:00`);
//   activePower.push((Math.random() * 1000).toFixed(2)); // 0~1000kW
//   reactivePower.push((Math.random() * 100).toFixed(2)); // 0~100kVar
// }

// 假设日出和日落时间（根据实际情况调整）
const sunriseHour = 6; // 日出时间 6:00
const sunsetHour = 18; // 日落时间 18:00


function Option(chartData = []) {
  console.log('chartData', chartData);
  
  const hours = [];
  const activePower = []; // 有功功率 kW
  const reactivePower = []; // 无功功率 kVar

  const min = dayjs().startOf('day').valueOf()
  const max = dayjs().endOf('day').valueOf()

  // 时间戳 -> { p, q } 映射，供 tooltip 按当前时间联动查找有功/无功
  const dataMap = new Map();

  for (const elem of chartData) {
    const t = dayjs(elem.record_time).valueOf()
    hours.push(t);
    activePower.push([t, elem.p]);
    reactivePower.push([t, elem.q]);
    dataMap.set(t, { p: elem.p, q: elem.q });
  }

  /**
   * @type {import('echarts').EChartsOption}
   */
  const option = {
    grid: [
      {
        left: 100,
        right: 100,
        height: 200,
      },
      {
        left: 100,
        right: 100,
        top: 350,
        bottom: 20,
      }
    ],
    tooltip: {
      trigger: 'axis',
      show: true,
      formatter(params) {
        const arr = Array.isArray(params) ? params : [params];
        // 取出当前指针对应的时间戳
        const point = arr.find(p => Array.isArray(p.value));
        if (!point) return '';
        const t = point.axisValue ?? point.value[0];
        const rec = dataMap.get(t) || {};
        const p = Number(rec.p).toFixed(2) ?? '-';
        const q = (rec.q) ?? '-';
        return [
          dayjs(t).format('YYYY-MM-DD HH:mm:ss'),
          `${$str.getKey('光伏监控/有功功率')}: ${p} kW`,
          `${$str.getKey('光伏监控/无功功率')}: ${q} kVar`,
        ].join('<br/>');
      }
    },
    // tooltip: createTooltip(),
    axisPointer: {
      link: { xAxisIndex: 'all' },
      snap: true,
      label: {
        backgroundColor: '#777'
      }
    },
    legend: {
      show: true,
      // right: 10,
      top: 0,
      left: 'center',
      icon: 'circle',
      itemWidth: 8,
      
      // textStyle: {
      //   color: textColor
      // }
    },
    // legend: {
    //   // data: ['有功功率', '无功功率'],
    //   top: 30
    // },
    xAxis: [
      {
        gridIndex: 0,
        type: 'time',
        min: min,
        max: max,
        // data: hours,
        name: $str.getKey('光伏监控/时间'),
        nameLocation: 'end',
        nameGap: 30,
        axisLabel: {
          formatter(value){
            return dayjs(value).format('HH:mm')
          } 
        }
      },
      {
        gridIndex: 1,
        type: 'time',
        min: min,
        max: max,
        // data: hours,
        name: $str.getKey('光伏监控/时间'),
        nameLocation: 'end',
        nameGap: 30,
        axisLabel: {
          formatter(value){
            return dayjs(value).format('HH:mm')
          } 
        }
      }
    ],
    yAxis: [
      {
        gridIndex: 0,
        type: 'value',
        name: $str.getKey('光伏监控/有功功率') + ' (kW)',
        position: 'left',
        axisLabel: {
          formatter: '{value} kW'
        }
      },
      {
        gridIndex: 1,
        type: 'value',
        name: $str.getKey('光伏监控/无功功率') + ' (kVar)',
        position: 'left',
        axisLabel: {
          formatter: '{value} kVar'
        }
      }
    ],
    series: [
      {

        name: $str.getKey('光伏监控/有功功率'),
        type: 'line',
        data: activePower,
        xAxisIndex: 0,
        yAxisIndex: 0,
        smooth: true,
        showSymbol: false,
        // symbolSize: 5,
        lineStyle: {
          color: '#5470c6'
        },

      },
      {
        name: $str.getKey('光伏监控/无功功率'),
        type: 'line',
        data: reactivePower,
        xAxisIndex: 1,
        yAxisIndex: 1,
        smooth: true,
        showSymbol: false,
        lineStyle: {
          color: '#91cc75'
        }
      },
      {
        name: $str.getKey('光伏监控/日出日落时间'),
        type: 'line',
        data: [],
        xAxisIndex: 0,
        yAxisIndex: 0,
        markLine: getMarkLine(),
        markArea: getMarkArea(),
        lineStyle: {
          opacity: 0
        },
        itemStyle: {
          color: '#F9C75F'
        }
      },
      {
        name: $str.getKey('光伏监控/日出日落时间'),
        type: 'line',
        data: [],
        xAxisIndex: 1,
        yAxisIndex: 1,
        markLine: getMarkLine(),
        markArea: getMarkArea(),
        lineStyle: {
          opacity: 0
        },
        itemStyle: {
          color: '#F9C75F'
        }
      }
    ]
  };



  return option;
}



function getMarkLine() {
  const today = dayjs().format('YYYY-MM-DD');
  const sunriseTime = dayjs(`${today} ${sunriseHour}:00:00`).valueOf();
  const sunsetTime = dayjs(`${today} ${sunsetHour}:00:00`).valueOf();

  
  return {
    data: [
      {
        xAxis: sunriseTime,
        name: $str.getKey('光伏监控/日出'),
        label: {
          formatter: `${$str.getKey('光伏监控/日出')} ${dayjs(sunriseTime).format('HH:mm')}`,
          position: 'end',
          color: '#86CB67'
        },
        lineStyle: {
          type: 'dashed',
          color: '#86CB67'
        }
      },
      {
        xAxis: sunsetTime,
        name: $str.getKey('光伏监控/日落'),
        label: {
          formatter: `${$str.getKey('光伏监控/日落')} ${dayjs(sunsetTime).format('HH:mm')}`,
          position: 'end',
          color: '#F9C75F'
        },
        lineStyle: {
          type: 'dashed',
          color: '#F9C75F'
        }
      }
    ]
  }
}

function getMarkArea() {
  const today = dayjs().format('YYYY-MM-DD');
  const startTime = dayjs(`${today} 00:00:00`).valueOf();
  const sunriseTime = dayjs(`${today} ${sunriseHour}:00:00`).valueOf();
  const sunsetTime = dayjs(`${today} ${sunsetHour}:00:00`).valueOf();
  const endTime = dayjs(`${today} 23:59:59`).valueOf();
  
  return {
    data: [
      [
        {
          xAxis: startTime,
          itemStyle: {
            color: `rgba(255, 255, 0, 0.1)`
          },
        },
        {
          xAxis: sunriseTime,
          itemStyle: {
            color: `rgba(255, 255, 0, 0.1)`
          },
        }
      ],
      [
        {
          xAxis: sunriseTime,
          itemStyle: {
            color: `rgba(0, 255, 0, 0.1)`
          },
        },
        {
          xAxis: sunsetTime,
          itemStyle: {
            color: `rgba(0, 255, 0, 0.1)`
          },
        }
      ],
      [
        {
          xAxis: sunsetTime,
          itemStyle: {
            color: `rgba(255, 255, 0, 0.1)`
          },
        },
        {
          xAxis: endTime,
          itemStyle: {
            color: `rgba(255, 255, 0, 0.1)`
          },
        }
      ]
    ],
    label: {
      show: false
    }
  }
}


function DailyEnergyOption({ params, chartData }) {
  const { start, end } = params;
  const xAxisData = [];
  for (let i = dayjs(start); i <= dayjs(end); i = i.add(1, 'day')) {
    xAxisData.push(i.format('YYYY-MM-DD'));
  }

  const findDatabyDay = (day) => {
    return chartData.find(item => dayjs(item.record_time).format('YYYY-MM-DD') == day)
  }

  const seriesData = xAxisData.map(item => {
    const data = findDatabyDay(item)
    if (data) {      
      return Number(data.power_gen_d).toFixed(2)
    }
  })


  /**
   * @type {(import 'echarts').EChartsOption}
   */
  let option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      // containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: xAxisData,
        axisTick: {
          alignWithLabel: true
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '电量(kWh)',
      }
    ],
    series: [
      {
        name: '日发电量',
        type: 'bar',
        barWidth: 15,
        data: seriesData,//chartData.map((item) => Number(item.power_gen_d).toFixed(2))
      }
    ]
  };


  return option;
}


function CircleOption(percentage = 0) {

  const progress = Math.min(100, percentage)
  const rest = 100 - progress;

  /**
   * @type {import('echarts').EChartsOption}
   */
  const option = {
    grid: {
      left: '0%',
      right: '0%',
      top: '0%',
      bottom: '0%'
    },
    series: [{
      type: 'pie',
      radius: ['60%', '90%'],  // 内半径和外半径，形成环形
      center: ['50%', '50%'],
      startAngle: 90,          // 从顶部开始
      avoidLabelOverlap: false,
      silent: true,            // 禁用交互
      label: {
        show: false,
      },
      labelLine: {
        show: false
      },
      data: [
        {
          value: progress,           // 进度部分
          name: '进度',
          itemStyle: {
            color: '#4083F3'
          }
        },
        {
          value: rest,           // 剩余部分
          name: '剩余',
          itemStyle: {
            color: '#eee'
          }
        }
      ]
    }]
  };

  return option;
}

export { Option, DailyEnergyOption, CircleOption }
